import { resolveHTTP } from '@/services/api'

const Api = resolveHTTP('/seo/friendly-urls')

Api.check = (seoId, url) => {
  return Api.resource.get(`/check/${seoId || ''}`, { params: { url: url } })
}

export default Api



// WEBPACK FOOTER //
// ./src/services/api/seo-friendly-urls.js